export default "__VITE_ASSET__b4f4b29d__"